<ng-container *ngIf="!isMobile; else mobileView">
  <ion-header>
    <codere-navbar titulo="Preferencias"></codere-navbar>
    <!-- user-section-title mobile & desktop -->
    <user-section-title [sectionTitle]="'oSubT'"></user-section-title>
  </ion-header>
  <ion-content>
    <ion-list class="user-list" radio-group (ionChange)="changeCuotaAccept()" [(ngModel)]="selectedCuotaChange">
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange0' | translate}}<!--Aceptar cualquier cambio de cuota--></ion-label>
          <ion-radio value="0"></ion-radio>
        </ion-item>
      </div>
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange1' | translate}}<!--Aceptar cuotas m&aacute;s altas--></ion-label>
          <ion-radio value="1"></ion-radio>
        </ion-item>
      </div>
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange2' | translate}}<!--No aceptar cambio de cuotas--></ion-label>
          <ion-radio value="2"></ion-radio>
        </ion-item>
      </div>
    </ion-list>
    <codere-footer></codere-footer>
  </ion-content>
</ng-container>
<ng-template #mobileView>
  <ion-header>
    <user-section-title [sectionTitle]="'oSubT'"></user-section-title>
  </ion-header>
  <ion-content>
    <ion-list class="user-list" radio-group (ionChange)="changeCuotaAccept()" [(ngModel)]="selectedCuotaChange">
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange0' | translate}}<!--Aceptar cualquier cambio de cuota--></ion-label>
          <ion-radio value="0"></ion-radio>
        </ion-item>
      </div>
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange1' | translate}}<!--Aceptar cuotas m&aacute;s altas--></ion-label>
          <ion-radio value="1"></ion-radio>
        </ion-item>
      </div>
      <div class="user-input-container">
        <ion-item>
          <ion-label>{{'cuotachange2' | translate}}<!--No aceptar cambio de cuotas--></ion-label>
          <ion-radio value="2"></ion-radio>
        </ion-item>
      </div>
    </ion-list>
    <codere-footer></codere-footer>
  </ion-content>
</ng-template>
